import api from "../services/api";

// user list
export const createUserList = (data) => {
    return api.post('admin/user/list/create', data);
}

export const getUserList = (queryParams = "") => {
    return api.get(`/admin/user/list/queries${queryParams}`);
};






export const updateRole = (data) => {
    return api.put('admin/privilegeRoles/update_role', data);
}

export const updateRoleStatus = (data) => {
    return api.put('admin/privilegeRoles/update_role_status', data);
}

export const deleteRole = (id) => {
    return api.delete('admin/privilegeRoles/delete_role', {
        data: { _id: id }
    });
}



export const getSpinnerRoleList = (queryParams = "") => {
    return api.get(`/admin/privilegeRoles/spinner_role_list${queryParams}`);
};